import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.gps-loggers-show-page', () => {
  import('./internal/show').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.gps_loggers_index_page', () => {
  import('./internal/table').then(({ default: Component }) => Component());
});
